import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const reviews = [
  {
    quote:
      "We are really pleased with the new wet room & so far it seems to be working well! The standard of workmanship is excellent, as was the standard shown constantly by your staff. I would highly recommend you to anyone.",
    name: "Christine & Brian",
    location: "Edinburgh",
  },
  {
    quote:
      "Conan and his team arrived on time and after a short discussion about the problem went straight to work with a professional efficiency and focus that is rare. Having had many drainage companies come and give me advice over 20 years I can say without hesitation that Conan's team are by far the best, the most professional and the most informed that I have ever worked with.",
    name: "Sally H",
    location: "Edinburgh",
  },
];

const Testimonials = () => {
  return (
    <section
      id="testimonials"
      className="relative py-20 md:py-28 bg-[#151D33] border-y border-[#2C374D]"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <p className="text-xs uppercase tracking-[0.3em] text-[#D47A4A] mb-4">
            / 04 — What Clients Say
          </p>
          <h2 className="font-display text-4xl md:text-6xl text-white leading-[0.95] tracking-tight">
            REAL CUSTOMERS.
            <br />
            <span className="text-[#D47A4A]">REAL WORDS.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {reviews.map((r, i) => (
            <motion.figure
              key={r.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              className="relative bg-[#0B132B] border border-[#2C374D] hover:border-[#D47A4A]/60 transition-colors p-7 md:p-9 rounded-sm"
              data-testid={`testimonial-${i + 1}`}
            >
              <Quote
                className="absolute top-6 right-6 w-10 h-10 text-[#D47A4A]/15"
                aria-hidden
              />
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star
                    key={idx}
                    className="w-4 h-4 fill-[#D47A4A] text-[#D47A4A]"
                  />
                ))}
              </div>
              <blockquote className="text-base md:text-lg text-[#F8F9FA] leading-relaxed">
                "{r.quote}"
              </blockquote>
              <figcaption className="mt-7 pt-5 border-t border-[#2C374D] flex items-center justify-between">
                <div>
                  <p className="font-display text-lg md:text-xl text-white tracking-wide">
                    {r.name.toUpperCase()}
                  </p>
                  <p className="text-xs uppercase tracking-[0.22em] text-[#A0ABC0] mt-1">
                    {r.location}
                  </p>
                </div>
                <div className="w-10 h-px bg-[#D47A4A]" aria-hidden />
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
